import * as Ladda from 'ladda';

export function startLadda(selector) {
    const l = Ladda.create(document.querySelector(selector));
    l.start()
}

export function startLaddaByElement(element) {
    const l = Ladda.create(element);
    l.start()
}

export function stopLadda() {
    Ladda.stopAll();
}
